import React, { useState, useEffect } from 'react';
import { ChevronDown } from 'lucide-react';
import { weddingDetails, heroPhoto } from '../data/mock';
import { useLanguage } from '../LanguageContext';
import LanguageSwitcher from './LanguageSwitcher';

export const HeroSection = () => {
  const { t } = useLanguage();
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    const calculateTimeLeft = () => {
      const weddingDate = new Date(weddingDetails.date);
      const now = new Date();
      const difference = weddingDate - now;

      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
          seconds: Math.floor((difference / 1000) % 60)
        });
      }
    };

    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    // Preload hero image with lower quality
    const img = new Image();
    img.onload = () => setImageLoaded(true);
    img.src = heroPhoto;
  }, []);

  const scrollToStory = () => {
    document.getElementById('our-story')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="hero-section">
      <LanguageSwitcher />
      <div className="hero-overlay"></div>
      <div 
        className={`hero-image ${imageLoaded ? 'loaded' : ''}`}
        style={{ backgroundImage: `url(${heroPhoto})` }}
      ></div>
      
      <div className="hero-content">
        <div className="hero-text">
          <p className="bismillah">بِسْمِ اللهِ الرَّحْمٰنِ الرَّحِيْمِ</p>
          <h1 className="couple-names">
            {weddingDetails.groom} & {weddingDetails.bride}
          </h1>
          <div className="decorative-line"></div>
          <p className="hero-subtitle">{t('hero.sayYes')}</p>
          <p className="wedding-date">{t('hero.date')}</p>
          <p className="wedding-location">{t('hero.location')}</p>
        </div>

        <div className="countdown-container">
          <div className="countdown-item">
            <span className="countdown-number">{timeLeft.days}</span>
            <span className="countdown-label">{t('hero.days')}</span>
          </div>
          <div className="countdown-divider">:</div>
          <div className="countdown-item">
            <span className="countdown-number">{timeLeft.hours}</span>
            <span className="countdown-label">{t('hero.hours')}</span>
          </div>
          <div className="countdown-divider">:</div>
          <div className="countdown-item">
            <span className="countdown-number">{timeLeft.minutes}</span>
            <span className="countdown-label">{t('hero.minutes')}</span>
          </div>
          <div className="countdown-divider">:</div>
          <div className="countdown-item">
            <span className="countdown-number">{timeLeft.seconds}</span>
            <span className="countdown-label">{t('hero.seconds')}</span>
          </div>
        </div>

        <button onClick={scrollToStory} className="cta-button">
          {t('hero.discover')}
        </button>

        <div className="scroll-indicator" onClick={scrollToStory}>
          <ChevronDown className="scroll-icon" />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
